import {HRCareer} from "./HRCareer";
import {HRCareerDetail} from "./HRCareerDetail";
import {JSonSerializer} from "../../../model/JSonSerializer";

export class HRCareerAggregation {
    career =             new HRCareer();
    careerDetails =      new Array<HRCareerDetail>();

    _createFromArray(propertyName: string, data: any) {
        const serializer = new JSonSerializer();
        if ('careerDetails' === propertyName) {
            for (const bean of <HRCareerDetail[]> data) {
                const tmp = new HRCareerDetail();
                serializer.deserialize(bean, tmp);
                this.careerDetails.push(tmp);
            }
        }

    }
}
// End of class